import { RootState } from 'editor/src/store/index';

import { getNonPrintingPageFill, PageFill } from 'editor/src/util/gangSheet/isGangSheetProductUid';

const getEmptyPageDisplayFill = (state: RootState): PageFill | undefined =>
  getNonPrintingPageFill(state.design.designData?.product_uid);

export default getEmptyPageDisplayFill;
